// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"481":"87d5b5af","608":"d00e64af","677":"453198de","895":"a4772224"}[chunkId] + ".css";
};